@if (isEnabled) {
  <div class="sub-window" [class.expanded]="isExpanded">
    <div
      class="header"
      (click)="toggleWindow()"
      (keydown.enter)="toggleWindow()"
      (keydown.space)="toggleWindow()"
      tabindex="0"
      role="button"
      aria-label="Toggle sub window"
      >
      {{ windowTitle() }}
      <span class="arrow-icon" [class.rotated]="isExpanded"></span>
    </div>
    @if (isExpanded) {
      <div class="content">
        <ng-container *ngComponentOutlet="component(); inputs: { popupMode: true }"></ng-container>
      </div>
    }
  </div>
}
